import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import backarrow from "../../assets/svg/backarrow-white.svg";
import { ReactComponent as UnAuthorizedIcon } from "../../assets/svg/unauthorized.svg";
import { useNavigate } from "react-router-dom";
const UnAuthorized = () => {
    const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;
    const navigate = useNavigate();
    return (<Container fluid style={{ width: '100%', height: '100vh', padding: '0px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ width: '600px', height: '455px', background: '#FFFFFF', borderRadius: '24px', padding: '48px', gap: '32px', textAlign: 'center' }}>
            <UnAuthorizedIcon />
            <p className="mt-3" style={{ fontFamily: 'Satoshi', fontSize: '28px', fontWeight: '700', color: '#212172C' }}>Unauthorized !!</p>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <p style={{ width: '359px', fontFamily: 'Satoshi', fontSize: '15px', fontWeight: '400', color: '#212172C' }}>You don’t have an access to this page. Please go back to home for access application.</p>
            </div>
            <button onClick={() => { navigate(accountsUrl) }} style={{ backgroundColor: '#6929E2', color: '#FFFFFF', border: 'none', borderRadius: '100px', fontWeight: '700', fontSize: '15px' }} className="px-4 py-2">
                <img src={backarrow} alt="back" className="px-2" />     Back to home
            </button>
        </div>
    </Container>);
};

export default UnAuthorized;